export default "__VITE_ASSET__82a8d98c__"